import {RootState} from "@/store";
import {ActionTree} from "vuex";
import {ConfigState} from "@/store/modules/config/index";
import {brainpowerClient} from "@/repositories/Repositories";

export const actions: ActionTree<ConfigState, RootState> = {

  featureFlags: ({commit}: any) => {
    brainpowerClient.get('appConfig')
      .then(response =>commit('setFeatureFlags', response.data))
  }
}
